export const bytesToMegabytes = (bytes, decimalPlaces = 2) => {
    if (typeof bytes !== 'number' || bytes < 0) {
        throw new Error('Введите положительное число в байтах');
    }

    const megabytes = bytes / (1024 * 1024);
    return megabytes.toFixed(decimalPlaces) + ' MB';
}
